import React from 'react';

const Web_API_Intro = () => {
  return (
    <div >
      <h1>Web_API_Intro</h1>
      <p>Placeholder component for: "Web API Intro"</p>
    </div>
  );
};

export default Web_API_Intro;
